import { render, staticRenderFns } from "./sprites.vue?vue&type=template&id=18e8f201&scoped=true&"
import script from "./sprites.vue?vue&type=script&lang=js&"
export * from "./sprites.vue?vue&type=script&lang=js&"
import style0 from "./sprites.vue?vue&type=style&index=0&id=18e8f201&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e8f201",
  null
  
)

export default component.exports